module.exports = __webpack_public_path__ + "img/nd.6198fbaf.svg";